<mat-card class="cardWithShadow">
  <mat-card-header class="d-flex">
    <div class="m-r-auto">
      <mat-card-title>Latest Issues</mat-card-title>
      <!-- <mat-card-subtitle class="mat-body-1">Best Products</mat-card-subtitle> -->
    </div>
    <!-- <mat-form-field class="theme-select" appearance="outline">
      <mat-select value="mar">
        @for(month of months; track month.viewValue) {
        <mat-option [value]="month.value">
          {{ month.viewValue }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field> -->
  </mat-card-header>
  <mat-card-content>
    <div class="table-responsive h-100 m-t-30">
      <table mat-table [dataSource]="dataSource" class="w-100">

        <!-- Name Column -->
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef class="f-w-600 mat-subtitle-1 f-s-14">
            Issue
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            {{ element.code }}
          </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef class="f-w-600 mat-subtitle-1 f-s-14">
            message
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.message | titlecase }}
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef class="f-w-600 mat-subtitle-1 f-s-14">
            createdAt
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            {{ element.createdAt }}
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="trend">
          <th mat-header-cell *matHeaderCellDef class="f-w-600 mat-subtitle-1 f-s-14">
            createdAt
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            {{ element.trend }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
            Action
          </th>
          <td mat-cell *matCellDef="let element" class="action-link">
            <a (click)="openDialog('Resolve', element)" class="m-r-10 cursor-pointer">
              <mat-icon class="icon-18">edit</mat-icon>
            </a>
            <!-- <a (click)="openDialog('Delete', element)" class="m-r-10 cursor-pointer">
              <mat-icon class="icon-18">delete</mat-icon>
            </a> -->
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>